import moment from 'moment';

export { poiWatch };
// @ts-check

/** @type {import('./types/reports.types').ReportsContent} */
const poiWatch = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'poiTotalCount', header: 'Total POI' },
          { field: 'poiTotalTime', header: 'Total Time' },
          { field: 'poiProductiveCount', header: 'Productive POI Count' },
          { field: 'poiProductiveTime', header: 'Productive POI Time' },
          { field: 'poiNonProductiveCount', header: 'Non Productive POI Count' },
          { field: 'poiNonProductiveTime', header: 'Non Productive POI Time' },
          { field: 'poiOtherCount', header: 'Other POI Count' },
          { field: 'poiOtherTime', header: 'Other POI Time' },
        ],
      },
      pdf: {
        title: 'POI - Watch - Summary',
        colsWidth: [80, 70, 70, 70, 70, 70, 70, 70, 70],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'poiName', header: 'POI Name' },
          { field: 'poiType', header: 'Type' },
          { field: 'time', header: 'Time' },
          { field: 'duration', header: 'Duration' }
        ],
      },
      pdf: {
        title: 'POI - Watch - Breakdown',
        colsWidth: [80, 70, 70, 70, 70],
      },
    },
    {
      label: 'Chart',
      icon: 'event',
      pdf: { title: 'Summary', colsWidth: [100, 100, 100, 100, 100] },
      view: {
        type: 'chart',
        content: [{ header: 'tableHeader', field: 'objectKey' }],
      },
    },
  ];
};

